import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";

const useStyles = createUseStyles((_) => ({
  container: {
    width: "100%",
    height: "var(--app-vh)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: colors.primary,
  },
  logo: {
    width: "226px",
    height: "130px",
  },

  customLabel: {
    margin: "9px 16px",
    "& .MuiTypography-root": {
      color: colors.WHITE,
      fontFamily: "Poppins-Regular",
      fontSize: 13,
    },
  },
  customCheckbox: {
    "& .MuiSvgIcon-root": {
      fontSize: 13,
      color: colors.WHITE,
    },
  },
  forgotPassword: {
    textAlign: "center",
  },
  subContainer2: {
    width: "266px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "25px",
  },
}));

export default useStyles;
